import { render, staticRenderFns } from "./FuckStupidTreatmentSetting.vue?vue&type=template&id=d303fee4&scoped=true"
import script from "./FuckStupidTreatmentSetting.vue?vue&type=script&lang=js"
export * from "./FuckStupidTreatmentSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d303fee4",
  null
  
)

export default component.exports